import qs from 'qs'
import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ITrainingRef, IGetRequestObject } from '../../interfaces'

type QueryObject = {
  activeOnly?: boolean
}

const getTrainingCategoriesRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })
  return {
    method: 'get',
    url: `${config.baseUrl}/TrainingCategories/ddl${queryString}`,
  }
}

const useTrainingCategoriesQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingRef[] | undefined
>({
  getRequest: getTrainingCategoriesRequest,
  getQueryKey: (params, queryObject) => [
    'training-categories',
    queryObject?.activeOnly,
  ],
})

const useTrainingCategoriesQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingRef[] | undefined, Error>,
) => {
  const trainingCategoriesQuery = useTrainingCategoriesQueryBase(
    undefined,
    queryObject,
    options,
  )
  return { ...trainingCategoriesQuery }
}

export default useTrainingCategoriesQuery
